// --------------------Quick Fixes----------------------//

import AOS from 'aos';

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#fff" width="40" height="36"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

// --------------------Lineup modifier----------------------//
function modifyFeatureLineup() {
  function cropText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) : text;
  }

  function createContentWrapper(titleText, croppedTitle, descriptionText) {
    return `
      <span class="featureLineup-content">
        <h4 class="featureLineup-content-title" title="${titleText}" aria-label="${titleText}">${croppedTitle}</h4>
        ${descriptionText ? `<span class="featureLineup-content-description">${descriptionText}</span>` : ''}
      </span>
    `;
  }

  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() > containerSize) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find('.featureLineupImage');
    const $title = $element.find('.featureLineup-title');
    const $description = $element.find('.featureLineup-text');
    const $moreBtn = $element.find('.featureLineup-more');

    const titleText = $title.text().trim();
    const croppedTitle = cropText(titleText, 35);
    const descriptionText = $description.text().trim();

    const contentWrapper = createContentWrapper(titleText, croppedTitle, descriptionText);
    const wrapperAux = `
    <span class="featureLineup-text">
      ${contentWrapper}
    </span>
    `;

    $title.remove();
    $description.remove();
    lineupButtonsGrid($element);
    $imageContainer.append(wrapperAux);
    $imageContainer.find('.featureLineup-content').append($moreBtn);
  });
}

function cloneDirections() {
  const directionsBtn = $('.standAloneDirections').attr('href');
  $('.map-directions .button').attr('href', directionsBtn);
}

function wrapDirections() {
  const directionsPins = $('.directionsPin');
  const directionsText = $('.standAloneDirections');
  const directionsIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="#ffffff" d="M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152l0 270.8c0 9.8-6 18.6-15.1 22.3L416 503l0-302.6zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6l0 251.4L32.9 502.7C17.1 509 0 497.4 0 480.4L0 209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77l0 249.3L192 449.4 192 255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"/></svg>`;

  const directionsWrapper = $('<div class="directionsWrapper"></div>');
  directionsPins.html(directionsIcon);
  directionsPins.appendTo(directionsWrapper);
  directionsText.appendTo(directionsWrapper);
  directionsWrapper.prependTo('.header .top-header');
  cloneDirections();
}

function modifyWeatherBug() {
  const weatherBugInterval = setInterval(() => {
    const weatherBugDescription = $('#weatherBugDescription').text();
    const weatherBugWidget = $('#weatherBugWidget');

    if (!weatherBugWidget.hasClass('weatherBugSet') && weatherBugDescription !== '') {
      weatherBugWidget.addClass('weatherBugSet');
      const findSpace = weatherBugDescription.lastIndexOf(' ');
      const res = weatherBugDescription.substring(findSpace, weatherBugDescription.length);

      $('#weatherBugDescription').html(res);
    }
  }, 12);

  // Clear interval on page unload to prevent memory leaks
  $(window).on('unload', () => clearInterval(weatherBugInterval));
}

function modifyEmailSignup() {
  $('.emailSignup').prepend('<div class="emailSignupTitle"></div>');
  $('.emailSignupText').text('Join our email newsletter');
  $('.emailInputField label').show();
  $('.emailSubmitButton').text('Sign Up');
}

function applyAOS(items, effect) {
  const delayIncrement = 150;
  let currentDelay = 400;
  items.each(function () {
    currentDelay += delayIncrement;
    $(this).attr({
      'data-aos': effect,
      'data-aos-easing': 'ease-in-out',
      'data-aos-duration': currentDelay.toString(),
      'data-aos-once': 'false',
      'data-aos-delay': currentDelay.toString(),
    });
  });
}
window.applyAOS = applyAOS;

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  wrapDirections();

  if (window.location.pathname === '/') {
    modifyEmailSignup();
  }

  // if is not homepage then modify featureLineup
  if (!$('body').hasClass('homepage')) {
    modifyFeatureLineup();
  }
});

$(window).load(() => {
  // ---
  modifyWeatherBug();
  AOS.init();
});
